function setRem() {
 
  const baseSize = 16; // 基准大小
 
  const scale = document.documentElement.clientWidth / 1440; // 设计稿宽度为 1440PX
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'; // 限制最大缩放比例
 
}
 
 
setRem();
 
window.addEventListener('resize', setRem);



//////////////////
// WEBPACK FOOTER
// ./utils/index.js
// module id = DHvs
// module chunks = 0